module.exports = __webpack_public_path__ + "media/images/ecommerce/storage-cc73871b721be8952e568dd152441e88.png";